import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
import MedicalExpensesBenefit from '../MedicalExpensesBenefit/index';
import TripInterruptionBenefit from '../TripInterruptionBenefit/index';
import TripDelayBenefit from '../TripDelayBenefit/index';
import BaggageBenefit from '../BaggageBenefit/index';
import AccidentalDeathAndDismemberment from '../AccidentalDeathAndDismemberment/index';
import RepatriationExpenseBenefit from '../RepatriationExpenseBenefit/index';
import InitDeclaration from '../InitDeclaration/index';
import FraudNotice from '../FraudNotice/index';
import AuthorizationCrum from '../AuthorizationCrum/index';
import SureGoAllBenefits from '../SureGoAllBenefits/index';
import DuesProtectPermissions from '../DuesProtectPermissions/index';
import DuesProtectPrivacyStatements from '../DuesProtectPrivacyStatements/index';
import DuesProtectHipaaNotice from '../DuesProtectHipaaNotice/index';
import P from '../../../../../components/P';
import OptionsContainer from '../../../components/OptionsContainer';
import { appConfig } from './../../../../../configureApp';
import Textbox from '../../../components/Textbox';
import FlexBox from '../../../../../components/FlexBox';
import { injectIntl, intlShape } from 'react-intl';
import {
  DeclarationSection,
  StandardConsentSection,
  VisitorsToCanadaSection,
  DuesProtectSection,
} from './components';
import {
  listCodeForDuesProtect,
} from '../../../dataMapper/claimCodeMapper';

function SubmitClaim(props) {
  const {
    submitted,
    signature,
    handleChange,
    emailAddress,
    showElectronicConsentDocument,
    electronicConsentDocument,
    errorEmails,
    TPAName,
    carrier,
    insuredsList,
    isClaimGroupAllowed,
    declarationSignature,
    privacyActAuthorisationSignature,
    showWarningMissingRequiredDocument,
    showWarningInvalidRequiredDocument,
    warningMissingRequiredDocument,
    isVisitorsToCanada,
    intl,
    showInsuredMultiClaimant,
    isClaimForFieldEnabled } = props;

  const { selectedBenefits } = props.stepWhatHappenedData;

  // Computed values
  const isMultipleClaimFor = insuredsList.length > 1 && isClaimGroupAllowed;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function')
    ? selectedBenefits.toJS()
    : (selectedBenefits || []);
  const isVisibleDuesProtect = list.filter((d) =>
    listCodeForDuesProtect.filter((c) => c === d.claimCode).length > 0
  ).length > 0;
  const isReadOnly = submitted;

  // Determine which section to render based on conditions
  const isTugoApp = appConfig.reactAppEnv === 'tugo';
  const shouldShowTugoAppSection = isVisitorsToCanada || isTugoApp;
  const shouldShowDeclaration = !shouldShowTugoAppSection && !isVisibleDuesProtect && isClaimForFieldEnabled;
  const shouldShowStandardConsent = !shouldShowTugoAppSection && !isVisibleDuesProtect && !isClaimForFieldEnabled;
  const shouldShowDuesProtect = isVisibleDuesProtect;
  return (
    <div>
      {(!isVisibleDuesProtect && !showInsuredMultiClaimant && !shouldShowTugoAppSection) &&
        <Section>
          <ControlContainer>
            <P style={{ fontWeight: 'bold' }}>
              <FormattedMessage {...messages.declaration} />
            </P>
            <hr style={{ height: 1, backgroundColor: 'black', border: 'none' }}></hr>
            <P>
              <FormattedMessage {...messages.declarationText1} />
            </P>
            <P>
              <FormattedMessage {...messages.declarationText2} />
            </P>
            <li style={{ marginLeft: 40 }}>
              <FormattedMessage {...messages.declarationText3} />
            </li>
            <div className={'row'}>
              <div className={'form-group col-md-6 col-sm-9'}>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="declarationSignature"
                    checked={declarationSignature === true}
                    onChange={handleChange('form.declarationSignature')}
                  />
                  <span>
                    <FormattedMessage {...messages.iAgreeToTheAboveCondition} id={messages.iAgreeToTheAboveCondition.id} />
                  </span>
                </OptionsContainer>
              </div>
            </div>
            <hr style={{ height: 1, backgroundColor: 'black', border: 'none' }}></hr>
            <Section>
              <ControlContainer>
                <P style={{ fontWeight: 'bold' }}>
                  <FormattedMessage {...messages.privacyActAuthorisation} id={messages.privacyActAuthorisation.id} />
                </P>
                <P>
                  <FormattedMessage {...messages.privacyActAuthorisationText1} />
                </P>
                <P>
                  <FormattedMessage {...messages.privacyActAuthorisationText2} />
                </P>
                <li style={{ marginLeft: 40 }}>
                  <FormattedMessage {...messages.privacyActAuthorisationText3} />
                </li>
                <li style={{ marginLeft: 40 }}>
                  <FormattedMessage {...messages.privacyActAuthorisationText4} />
                </li>
              </ControlContainer>
            </Section>
            <div className={'row'}>
              <div className={'form-group col-md-6 col-sm-9'}>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="privacyActAuthorisationSignature"
                    checked={privacyActAuthorisationSignature === true}
                    onChange={handleChange('form.privacyActAuthorisationSignature')}
                  />
                  <span>
                    <FormattedMessage {...messages.iAgreeToTheAboveCondition} id={messages.iAgreeToTheAboveCondition.id} />
                  </span>
                </OptionsContainer>
              </div>
            </div>
          </ControlContainer>
        </Section>
      }
      {(!isVisibleDuesProtect && showInsuredMultiClaimant && !shouldShowTugoAppSection) &&
        <Section>
          <ControlContainer>
            <P>
              <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} {...messages.youAreAboutToSubmitYourClaimAnd.id} />
            </P>
            {<SureGoAllBenefits TPAName={TPAName} carrier={carrier} />}
            {showFraudNotice === true && <InitDeclaration />}
            {showFraudNotice === false && <FraudNotice />}
            {(showWarningMissingRequiredDocument === true || showWarningInvalidRequiredDocument === true) &&
              <div className={'row'}>
                <div className={'form-group col-md-12'}>
                  <ControlContainer>
                    {showWarningMissingRequiredDocument && (
                      <div>
                        <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                          <FormattedMessage {...messages.warningMissingRequiredDocument} />
                        </h5>
                        <P>
                          <FormattedMessage {...messages.warningMissingRequiredDocumentText1} />
                        </P>
                      </div>
                    )}

                    {showWarningInvalidRequiredDocument && (
                      <div>
                        <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                          <FormattedMessage {...messages.warningInvalidRequiredDocument} />
                        </h5>
                        <P>
                          <FormattedMessage {...messages.warningInvalidRequiredDocumentText1} />
                        </P>
                      </div>
                    )}
                    <div className={'row'}>
                      <div className={'form-group col-md-12'}>
                        <FlexBox>
                          <OptionsContainer>
                            <FormattedMessage {...messages.wouldYouLikeToProceedToNextSteps} />
                          </OptionsContainer>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              value="true"
                              checked={warningMissingRequiredDocument === 'true'}
                              onChange={handleChange('form.warningMissingRequiredDocument')}
                            />
                            <FormattedMessage {...messages.yes} />
                          </OptionsContainer>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="radio"
                              value="false"
                              checked={warningMissingRequiredDocument === 'false'}
                              onChange={handleChange('form.warningMissingRequiredDocument')}
                            />
                            <FormattedMessage {...messages.no} />
                          </OptionsContainer>
                        </FlexBox>
                      </div>
                    </div>
                  </ControlContainer>
                </div>
              </div>
            }
            {showElectronicConsentDocument === true &&
              <div>
                <div className={'row'}>
                  <div className={'form-group col-md-8 col-sm-12'}>
                    <span>
                      <a href="https://www.mysurego.com/terms-and-conditions/" target="_blank" style={{ color: 'blue' }}><FormattedMessage {...messages.OnlineConsentDoc} id={messages.OnlineConsentDoc.id} /></a>
                    </span>
                  </div>
                  <div className={'form-group col-md-12'}>
                    <FlexBox>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="true"
                          checked={electronicConsentDocument === 'true'}
                          onChange={handleChange('form.electronicConsentDocument')}
                        />
                        <FormattedMessage {...messages.yes} />
                      </OptionsContainer>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="false"
                          checked={electronicConsentDocument === 'false'}
                          onChange={handleChange('form.electronicConsentDocument')}
                        />
                        <FormattedMessage {...messages.no} />
                      </OptionsContainer>
                      {isMultipleClaimFor &&
                        <OptionsContainer>
                          <FormattedMessage {...messages.agreeSureGoPolicyv2} />
                        </OptionsContainer>
                      }
                      {!isMultipleClaimFor &&
                        <OptionsContainer>
                          <FormattedMessage {...messages.agreeSureGoPolicy} id={messages.agreeSureGoPolicy.id} />
                        </OptionsContainer>
                      }
                    </FlexBox>
                  </div>
                  <div className={'form-group col-md-8 col-sm-12'}>
                    <span>
                      <FormattedMessage {...messages.iHaveReadAndAgree} id={messages.iHaveReadAndAgree.id} />
                    </span>
                  </div>
                  {(electronicConsentDocument === 'true' && !isMultipleClaimFor) &&
                    <div className={'col-sm-8 form-group'}>
                      <span>
                        <FormattedMessage {...messages.theEmailAddressToBeUsed} id={messages.theEmailAddressToBeUsed.id} />
                      </span>
                      <Textbox
                        disabled={isReadOnly}
                        name="emailAddress"
                        type="email"
                        onChange={handleChange('form.emailAddress')}
                        value={emailAddress}
                      />
                      {errorEmails && <p style={{ color: 'red', fontSize: '13px' }}>{errorEmails}</p>}
                    </div>
                  }
                  <div className={'form-group col-md-8 col-sm-12'}>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="signature"
                        checked={signature === true}
                        onChange={handleChange('form.signature')}
                      />
                      <span>
                        <FormattedMessage {...messages.agree} id={messages.agree.id} />
                      </span>
                    </OptionsContainer>
                  </div>
                </div>
              </div>
            }
            {showElectronicConsentDocument !== true &&
              <div className={'row'}>
                <div className={'form-group col-md-6 col-sm-9'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="signature"
                      checked={signature === true}
                      onChange={handleChange('form.signature')}
                    />
                    <span>
                      <FormattedMessage {...messages.agree} id={messages.agree.id} />
                    </span>
                  </OptionsContainer>
                </div>
              </div>
            }
            <P style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
              <FormattedMessage {...messages.clickSubmitClaim} id={messages.clickSubmitClaim.id} />
            </P>
            <Section>
              <ControlContainer>
                <P style={{ fontWeight: 'bold' }}>
                  <FormattedMessage {...messages.privacyStatement} id={messages.privacyStatement.id} />
                </P>
                <P style={{ fontStyle: 'italic' }}>
                  <FormattedMessage {...messages.privacyStatementMessage1} id={messages.privacyStatementMessage1.id} /> <a href={appConfig.privacyStatementUrl} target="_blank"><FormattedMessage {...messages.here} id={messages.here.id} /></a>. <FormattedMessage {...messages.privacyStatementMessage2} id={messages.privacyStatementMessage2.id} />
                </P>
              </ControlContainer>
            </Section>
          </ControlContainer>
        </Section>
      }
      {isVisibleDuesProtect &&
        <Section>
          <ControlContainer>
            <P>
              <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} id={messages.youAreAboutToSubmitYourClaimAnd.id} />
            </P>
            {<DuesProtectPermissions />}
            <div className={'row'}>
              <div className={'form-group col-md-9 col-sm-9'}>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="signature"
                    checked={signature === true}
                    onChange={handleChange('form.signature')}
                  />
                  <span>
                    <FormattedMessage {...messages.agreeDuesProtect} id={messages.agreeDuesProtect.id} />
                  </span>
                </OptionsContainer>
              </div>
            </div>
            {<DuesProtectPrivacyStatements />}
            {<DuesProtectHipaaNotice />}
          </ControlContainer>
        </Section>
      }
      {shouldShowDeclaration && (
        <DeclarationSection
          isReadOnly={isReadOnly}
          declarationSignature={declarationSignature}
          privacyActAuthorisationSignature={privacyActAuthorisationSignature}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {shouldShowTugoAppSection && (
        <VisitorsToCanadaSection
          TPAName={TPAName}
          carrier={carrier}
          showFraudNotice={appConfig.showFraudNotice}
          showWarningMissingRequiredDocument={showWarningMissingRequiredDocument}
          showWarningInvalidRequiredDocument={showWarningInvalidRequiredDocument}
          warningMissingRequiredDocument={warningMissingRequiredDocument}
          showElectronicConsentDocument={showElectronicConsentDocument}
          electronicConsentDocument={electronicConsentDocument}
          emailAddress={emailAddress}
          errorEmails={errorEmails}
          signature={signature}
          isMultipleClaimFor={isMultipleClaimFor}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {shouldShowStandardConsent && (
        <StandardConsentSection
          TPAName={TPAName}
          carrier={carrier}
          showFraudNotice={appConfig.showFraudNotice}
          showWarningMissingRequiredDocument={showWarningMissingRequiredDocument}
          showWarningInvalidRequiredDocument={showWarningInvalidRequiredDocument}
          warningMissingRequiredDocument={warningMissingRequiredDocument}
          showElectronicConsentDocument={showElectronicConsentDocument}
          electronicConsentDocument={electronicConsentDocument}
          emailAddress={emailAddress}
          errorEmails={errorEmails}
          signature={signature}
          isMultipleClaimFor={isMultipleClaimFor}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {shouldShowDuesProtect && (
        <DuesProtectSection
          signature={signature}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}
    </div>
  );
}

SubmitClaim.propTypes = {
  submitted: PropTypes.bool,
  signature: PropTypes.bool,
  emailAddress: PropTypes.any,
  handleChange: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
  showWarningMissingRequiredDocument: PropTypes.bool,
  showWarningInvalidRequiredDocument: PropTypes.bool,
  warningMissingRequiredDocument: PropTypes.string,
  showElectronicConsentDocument: PropTypes.bool,
  electronicConsentDocument: PropTypes.bool,
  errorEmails: PropTypes.any,
  TPAName: PropTypes.any,
  carrier: PropTypes.any,
  insuredsList: PropTypes.any,
  declarationSignature: PropTypes.bool,
  privacyActAuthorisationSignature: PropTypes.bool,
  isClaimGroupAllowed: PropTypes.bool,
  isVisitorsToCanada: PropTypes.bool,
  intl: intlShape.isRequired,
  showInsuredMultiClaimant: PropTypes.bool,
};

export default injectIntl(SubmitClaim);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/index.js